var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',{scopedSlots:_vm._u([{key:"links",fn:function(props){return [_c('sidebar-item',{attrs:{"link":{
            name: 'Logout',
            icon: 'ni ni-user-run text-primary',
            path: '/logout'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Switch',
            icon: 'ni ni-compass-04 text-primary',
          }}},[_c('sidebar-item',{attrs:{"link":{ name: 'Go to LinkedIn', path: '/mysynchronicity-linkedin' }}})],1),_c('sidebar-item',{attrs:{"link":{
            name: 'Facebook',
            icon: 'ni ni-planet text-primary',
            path: '/mysynchronicity-facebook'
          }}})]}}])}),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar'),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }